import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import { useRachelPresentation } from '../../hooks/useRachelPresentation';
import { useRachelStore } from '../../store/rachel.store';
import { selectIsRachelInputFocused } from '../../store/rachel.store.selectors';
import RachelEmptyConversationView from './RachelEmptyConversationView';
import { getFirstName } from './rachelEmptyConversation.utils';

const RachelEmptyConversation = () => {
  const { state } = useApplicationContext();
  const isInputFocused = useRachelStore(selectIsRachelInputFocused);
  const presentation = useRachelPresentation();
  const isOnPage = presentation.mode === 'page';

  return (
    <RachelEmptyConversationView
      userName={getFirstName(state.user?.name)}
      isFocused={isInputFocused || isOnPage}
      size={isOnPage ? 'large' : 'compact'}
    />
  );
};

export default RachelEmptyConversation;
